import { API_ENDPOINT } from '../constants';
import { HTTP } from './http.service';

export const HealthCheck = {
  validateToken: () => {
    return HTTP.get<any, any>(`${API_ENDPOINT.CORE}health-check`);
  }
};
